<template>
    <div class="">
        <h5 class="info-head">基本信息<span v-if="!isShowBasic" style="margin-left:12px;color:red;font-weight:normal;">(存在入库审批中的专业类别,无法修改)</span></h5>
        <el-form :model="basic" label-width="200px" :rules="rules" ref="basicForm" class="supplier-form">
            <el-form-item label="供应商单位名称：" prop="fnameL2">
                <el-input type="text" v-model.trim="basic.fnameL2" auto-complete="off" :disabled="hasYrz"></el-input>
            </el-form-item>
            <el-form-item label="业务对接人：" prop="fcallname">
                <el-input type="text" v-model.trim="user.fcallname" auto-complete="off" :disabled="hasYrz"></el-input>
            </el-form-item>
            <el-form-item label="业务对接人身份证：" prop="personInChangeNo">
                <el-input type="text" v-model="user.personInChangeNo" auto-complete="off" :disabled="hasYrz"></el-input>
            </el-form-item>
            <el-form-item label="公司名称（英文）：" prop="fnameen"><el-input type="text" v-model="basic.fnameen" auto-complete="off"></el-input></el-form-item>
            <el-form-item label="公司类型：" prop="fsuppliertypeid">
                <el-cascader @change="selectCompanyType" ref="companyTyper" v-model="companyType"
                             :disabled="hasYrz"
                             placeholder="输入搜索" expand-trigger="hover"
                             :options="companyTypes" :show-all-levels="false"
                             filterable change-on-select
                ></el-cascader>
            </el-form-item>
            <el-form-item label="成立日期：" prop="fbuilddate">
                <el-date-picker default-value="2010-01-01" v-model="basic.fbuilddate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd hh:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item label="法人代表：" prop="fenterprisemaster"><el-input type="text" v-model.trim="basic.fenterprisemaster" auto-complete="off"></el-input></el-form-item>
            <el-form-item label="法人代表身份证：" prop="fenterprisemasterid"><el-input type="text" v-model="basic.fenterprisemasterid" auto-complete="off"></el-input></el-form-item>
            <el-form-item label="地税登记号：" prop="flandtaxno"><el-input type="text" v-model="basic.flandtaxno" auto-complete="off"></el-input></el-form-item>
            <el-form-item label="国税登记号：" prop="fcentraltaxno"><el-input type="text" v-model="basic.fcentraltaxno" auto-complete="off"></el-input></el-form-item>
            <el-form-item label="统一社会信用代码：" prop="fbusinessnum"><el-input type="text" v-model="basic.fbusinessnum" :maxlength="20" auto-complete="off"></el-input></el-form-item>
            <el-form-item label="公司地址：" required>
                <el-col :span="10">
                    <el-form-item prop="fprovinceid">
                        <el-select v-model="basic.fprovinceid" @change="basic.fcityid = ''" placeholder="请选择" style="float:left">
                            <el-option
                                v-for="item,index in provinces"
                                :key="index"
                                :label="item.fnameL2"
                                :value="item.fid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="2">省</el-col>
                <el-col :span="10">
                    <el-form-item prop="fcityid">
                        <el-select v-model="basic.fcityid" placeholder="请选择">
                            <el-option v-for="item in cities"
                                       :key="item.fid"
                                       :label="item.fnameL2"
                                       :value="item.fid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="2">市</el-col>
            </el-form-item>
            <el-form-item label="工商注册日期：" prop="fbizregdate">
                <el-date-picker default-value="2010-01-01" v-model="basic.fbizregdate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd hh:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item label="公司注册地址：" prop="cfcompanyaddres"><el-input type="text" v-model="basic.cfcompanyaddres" auto-complete="off"></el-input></el-form-item>
            <el-form-item label="公司办公地址：" prop="faddress"><el-input type="text" v-model="basic.faddress" auto-complete="off"></el-input></el-form-item>
            <el-form-item label="公司电话：" prop="flinkphone"><el-input type="text" v-model="basic.flinkphone" auto-complete="off" :maxlength="20"></el-input></el-form-item>
            <el-form-item label="公司传真：" prop="flinkfax"><el-input type="text" v-model="basic.flinkfax" auto-complete="off" :maxlength="20"></el-input></el-form-item>
            <el-form-item label="公司网址：" prop="fwebsite"><el-input type="text" v-model="basic.fwebsite" auto-complete="off" :maxlength="20"></el-input></el-form-item>
            <el-form-item label="公司邮箱：" prop="flinkmail"><el-input type="text" v-model="basic.flinkmail" auto-complete="off" :maxlength="20"></el-input></el-form-item>
            <el-form-item label="邮政编码：" prop="fpostnumber"><el-input type="text" v-model="basic.fpostnumber" auto-complete="off" :maxlength="6"></el-input></el-form-item>
            <el-form-item label="纳税人身份：" prop="ftaxpayertype">
                <el-select v-model="basic.ftaxpayertype" placeholder="请选择" style="float:left">
                    <el-option
                        v-for="name,index in taxpayerTypes"
                        :key="index+1"
                        :label="name"
                        :value="index+1+''">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div class="text-center">
            <el-button v-if="isShowBasic" :disabled="isSubmit" type="primary" @click="submit">提交</el-button>
        </div>
    </div>
</template>

<script type="text/babel">
    import { mapGetters, mapActions, mapMutations } from 'vuex'
    import {SELECT_PROVINCE,ADD_SERVICEAS,ADD_SPSS, UPDATE_TAXPAYER_TYPE,UPDATE_COMPANY_TYPE} from '@/store/mutation-types'
    import apis from '@/store/apis'
    import { basicRules } from '@/util/rules'

    export default {
        name: 'supplier',
        data () {
            return {
                rules: {
                    fnameL2: [
                        {required: true, message: '请输入供应商单位名称', trigger: 'blur'},
                        {validator: 'regexp', pattern: /^[\u4E00-\u9FA50-9A-Za-z（）() 、]+$/, message: '供应商名称只允许中英文（可包含括号、数字和空格）', trigger: 'blur'},
                        {validator: this.checkUpdateSname, message: '供应商名称重复', trigger:'blur'}
                    ],
                    fbusinessnum: [
                        { required: true, message: '请输入公司统一社会信用代码', trigger: 'change' },
                        {pattern:  /^(?!.*[\s])/g,message:'请勿输入空格、回车等非法字符',trigger:'blur'},
                        { min: 18, max: 18, message: '长度必须为18位' },
                        {validator: this.checkBusinessNum, trigger: 'blur' }
                    ],
                    ...basicRules
                },
                companyType: [],
                isSubmit:false
            }
        },
        computed:mapGetters(['user','basic','provinces','cities','companyTypes','productTypes','taxpayerTypes','isShowBasic','hasYrz']),
        watch:{
            'basic.fprovinceid': function changeProvince(pid){
                this.setPid(pid)
                this.getCities()
            },
            'isShowBasic'(val){
            },
            'hasYrz'(val){
            }
        },
        methods: {
            ...mapActions(['getProvinces','getCities','getProductTypes','getCompanyTypes','checkSUserStock','getStockInfo']),
            ...mapMutations({
                setPid: SELECT_PROVINCE,
                updateTaxpayerType: UPDATE_TAXPAYER_TYPE
            }),


            checkUpdateSname(rule, value, callback){
                this.$http.post('rest/api/completeFourInfo/checkUpdateSname',{
                    stockId: this.$root.stockId,
                    fnameL2: value
                }).then((res) =>{
                    if (res.data.result) {
                        callback()
                    } else {
                        callback(new Error(res.data.message))
                    }
                })
            },

            selectCompanyType(types){
                this.$nextTick(()=>{
                    let typer = this.$refs.companyTyper
                    this.companyType.fsuppliertypename = typer.getCheckedNodes()[0].label
                    this.companyType.fsuppliertypeid = typer.getCheckedNodes()[0].value
                    this.companyType.farParent = typer.getCheckedNodes()[0].path.join(',')
                    this.basic.fsuppliertypeid = this.companyType.fsuppliertypeid
                })
            },
            submit(){
                this.basic.fcallname = this.user.fcallname
                this.basic.personInChangeNo = this.user.personInChangeNo

                this.$refs.basicForm.validate(valid=>{
                    if(valid){
                        this.isSubmit=true;
                        this.$root.loading = true
                        this.checkSUserStock({
                            success:(res)=>{
                                this.isSubmit=false;
                                this.$root.loading = false
                                if(res.data.result){
                                    this.$confirm(res.data.message||'操作成功！', '', {
                                        confirmButtonText: '确定',
                                        showCancelButton: false,
                                        showClose: false,
                                        type: 'success',
                                        center: true
                                    }).then(() => {
                                        window.location.reload()
                                    },() => {
                                        window.location.reload()
                                    })
                                    window.sessionStorage.setItem(this.$route.name,'saved')
                                }else{
                                    this.$alert(res.data.message)
                                }
                            },error:(err)=>{
                                this.isSubmit=false;
                                this.$root.loading = false
                                this.$alert(err)
                            }
                        })
                    }
                })
            },
            checkBusinessNum(rule, value, callback) {
                if (!value) {
                    callback(new Error('统一社会信用代码必须填写'))
                } else {
                    this.$http.get(`/rest/api/dspUserApi/checkFBusinessNum?fbusinessnum=${value}&id=${encodeURIComponent(this.basic.id)}`).then((res) => {
                        if (res.data.result) {
                            callback()
                        } else {
                            callback(new Error(res.data.message))
                        }
                    })
                }
            }
        },
        created(){
            this.$root.loading = true
            Promise.all([this.getProductTypes(),
                this.getCompanyTypes(),
                this.getProvinces(),
            ]).then(r=>{
                this.$nextTick(function(){
                    if(this.basic.fprovinceid){
                        this.setPid(this.basic.fprovinceid)
                        this.getCities()
                    }
                    this.$root.loading = false
                })
            }).catch(err=>this.$root.loading = false)

            this.$nextTick(function(){
                this.companyType = this.basic.farParent.split(',')
            })
        },
        mounted(){
            this.getStockInfo()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/dsp/supplier/Basic.vue